import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { userState } from './state-accessors';

export const getUserNotificationConfigsSelector = createSelector(
  (state) => get(state, 'userNotificationConfigs', {}),
  (userNotificationConfigs) => userNotificationConfigs,
);

export const userOriginalSiteSelector = createSelector(userState, (user) => get(user, 'site', {}));
